goog.provide("shadow.js.shim.module$$mui$material$Icon$default");
shadow.js.shim.module$$mui$material$Icon$default = shadow.js.shim.module$$mui$material$Icon.default;
